import { mutatorAction } from "satcheljs";
import { type SortColumn, type MailFolderTableQuery, type TableView } from "owa-mail-list-store";
import { getStore as getCategorySortStore } from "owa-mail-category-sort";
import { getMailboxInfo } from "owa-mail-mailboxinfo";
import virtualizedMailGroupHeadersStore from "../store/store";

const renameCategoryGroupHeaderMutator: (tableView: TableView, oldCategoryName: string, newCategoryName: string) => void = mutatorAction("renameCategoryGroupHeader", (tableView: TableView, oldCategoryName: string, newCategoryName: string): void => {
    if ((tableView.tableQuery as MailFolderTableQuery).sortBy?.sortColumn !== 14) {
        return;
    }
    
    const { categoryByRowKey } = getCategorySortStore(getMailboxInfo(tableView));
    let hasRenamedRows = false;
    for (const rowKey of tableView.rowKeys) {
        if (categoryByRowKey.get(rowKey) === oldCategoryName) {
            categoryByRowKey.set(rowKey, newCategoryName);
            hasRenamedRows = true;
        }
    }
    
    const headers = virtualizedMailGroupHeadersStore().virtualizedGroupHeaders;
    const header = headers.get(oldCategoryName);
    const renamedRowKeys = tableView.rowKeys.filter(rowKey => categoryByRowKey.get(rowKey) === newCategoryName);
    if (hasRenamedRows || (header && renamedRowKeys.length > 0)) {
        if (header) {
            headers.delete(oldCategoryName);
            header.headerId = newCategoryName;
            header.rowKeys = renamedRowKeys;
            headers.set(newCategoryName, header);
        }
        
        if (tableView.selectedGroupHeaders.has(oldCategoryName)) {
            const isSelected = tableView.selectedGroupHeaders.get(oldCategoryName) === true;
            tableView.selectedGroupHeaders.delete(oldCategoryName);
            tableView.selectedGroupHeaders.set(newCategoryName, isSelected);
        }
        if (tableView.headerToFocus === oldCategoryName) {
            tableView.headerToFocus = newCategoryName;
        }
        // Invalidate the virtualized header renderer even though the row keys are unchanged.
        tableView.rowPositionUpdatedCount = (tableView.rowPositionUpdatedCount ?? 0) + 1;
    }
});

export default renameCategoryGroupHeaderMutator;
